import { capitalize, lowerCase } from 'lodash-es'

export function displayLanguage(language) {
  return language === 'unknown' ? 'English' : capitalize(language)
}

export function getFlagAndAbbreviation(language) {
  switch (lowerCase(language)) {
    case 'bulgarian':
      return { icon: '🇧🇬', code: 'bg' }
    case 'catalan':
      return { icon: '🇦🇩', code: 'ca' }
    case 'croatian':
      return { icon: '🇭🇷', code: 'hr' }
    case 'danish':
      return { icon: '🇩🇰', code: 'da' }
    case 'dutch':
      return { icon: '🇳🇱', code: 'nl' }
    case 'unknown':
    case 'english':
      return { icon: '🇺🇸', code: 'en' }
    case 'finnish':
      return { icon: '🇫🇮', code: 'fi' }
    case 'french':
      return { icon: '🇫🇷', code: 'fr' }
    case 'german':
      return { icon: '🇩🇪', code: 'de' }
    case 'greek':
      return { icon: '🇬🇷', code: 'el' }
    case 'hungarian':
      return { icon: '🇭🇺', code: 'hu' }
    case 'indonesian':
      return { icon: '🇮🇩', code: 'id' }
    case 'italian':
      return { icon: '🇮🇹', code: 'it' }
    case 'malay':
      return { icon: '🇲🇾', code: 'ms' }
    case 'norwegian':
      return { icon: '🇳🇴', code: 'no' }
    case 'polish':
      return { icon: '🇵🇱', code: 'pl' }
    case 'portuguese':
      return { icon: '🇵🇹', code: 'pt' }
    case 'romanian':
      return { icon: '🇷🇴', code: 'ro' }
    case 'russian':
      return { icon: '🇷🇺', code: 'ru' }
    case 'serbian':
      return { icon: '🇷🇸', code: 'sr' }
    case 'slovak':
      return { icon: '🇸🇰', code: 'sk' }
    case 'spanish':
      return { icon: '🇪🇸', code: 'es' }
    case 'swedish':
      return { icon: '🇸🇪', code: 'sv' }
    case 'thai':
      return { icon: '🇹🇭', code: 'th' }
    case 'turkish':
      return { icon: '🇹🇷', code: 'tr' }
    case 'ukrainian':
      return { icon: '🇺🇦', code: 'uk' }
    case 'vietnamese':
      return { icon: '🇻🇳', code: 'vi' }
    default:
      return { icon: '', code: '--' }
  }
}
